module.exports = __webpack_public_path__ + "static/img/25.c9b749e4.png";